import * as React from 'react';
import s from './PriceQuoteActions.scss';
import { Print } from '@wix/wix-ui-icons-common/lazy';
import { WithTranslation, withTranslation } from 'react-i18next';
import { Button, IconButton, Notification } from '@wix/design-system';
import { PdfDownloader } from './PdfDownloader/PdfDownloader';
import { useState } from 'react';
import { harmonyPatchValue } from '../../../../utils/harmonyPatch';

export interface PriceQuoteActionsProps extends WithTranslation {
  status: string;
  withAskAQuestion: boolean;
  askAQuestion(): void;
  onAccept(): void;
  pdfUrl: string;
  token: string;
  print(): void;
}

const PriceQuoteActionsComp = ({
  status,
  askAQuestion,
  withAskAQuestion,
  onAccept,
  pdfUrl,
  token,
  print,
  t,
}: PriceQuoteActionsProps) => {
  const [showError, setShowError] = useState(false);
  const withUserActions = status === 'Sent';

  return (
    <>
      <Notification
        autoHideTimeout={4000}
        theme="error"
        show={showError}
        type="sticky"
        onClose={() => setShowError(false)}
      >
        <Notification.TextLabel>
          {t('translation:price-quote.actions.save-pdf.error')}
        </Notification.TextLabel>
        <Notification.CloseButton />
      </Notification>
      <div
        className={`${s.actions} ${withUserActions ? s.withUserActions : ''}`}
      >
        <div className={s.exportActions}>
          <IconButton
            priority={harmonyPatchValue(undefined, 'tertiary')}
            skin={harmonyPatchValue(undefined, 'dark')}
            dataHook="print-button"
            onClick={print}
          >
            <Print />
          </IconButton>
          <PdfDownloader
            text={t('translation:price-quote.actions.save-pdf')}
            token={token}
            pdfUrl={pdfUrl}
            onDownloadPDF={() => {}}
            onDownloadFail={() => {
              setShowError(true);
            }}
          />
        </div>

        <div className={s.userActions}>
          {!!withAskAQuestion && (
            <Button
              priority={harmonyPatchValue(undefined, 'secondary')}
              skin={harmonyPatchValue(undefined, 'dark')}
              className={s.askAQuestion}
              dataHook="ask-question-button"
              onClick={askAQuestion}
            >
              {t('translation:price-quote.actions.question')}
            </Button>
          )}
          {status === 'Sent' ? (
            <Button
              priority={harmonyPatchValue(undefined, 'primary')}
              skin={harmonyPatchValue(undefined, 'dark')}
              dataHook="accept-button"
              onClick={onAccept}
            >
              {t('translation:price-quote.actions.accept')}
            </Button>
          ) : null}
        </div>
      </div>
    </>
  );
};

const PriceQuoteActions = withTranslation()(PriceQuoteActionsComp);
export { PriceQuoteActions };
